import { useQuery } from "@tanstack/react-query"
import { useSearchParams, Navigate } from "react-router-dom"
import { useEffect } from "react"

import { useAuthContext } from "../services/auth"
import { getCheckoutResult } from "../services/api"
import Loading from "../components/Loading"
import { trackSubscription } from "../services/analytics"

export default function CheckoutResult() {
  const { user, error } = useAuthContext()

  const [searchParams] = useSearchParams()

  const sessionId = searchParams.get("session_id")
  const {
    data: session,
    isLoading,
    error: sessionError,
  } = useQuery({
    queryKey: ["session", user?.id, sessionId],
    queryFn: getCheckoutResult,
    enabled: !!user,
    refetchInterval: 1000,
  })

  // Track purchase when session is complete
  useEffect(() => {
    if (
      session &&
      session.status === "complete" &&
      session.payment_status === "paid"
    ) {
      const amount = session.amount / 100
      trackSubscription({
        value: amount,
        currency: session.currency.toUpperCase() || "USD",
      })
    }
  }, [session])

  if (error || sessionError) {
    return "Error fetching session. Please try again."
  }

  if (isLoading || session.session_status === "open") {
    return <Loading />
  }

  return <Navigate to="/" />
}
